import { Component, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import AuthenticateMixin from "@/common/mixins/auth.mixin";
import { ShiftFilterDto } from "@/types/shift.type";
import { getCurrentIsoDate } from "@/utils/date.util";

@Component({
  computed: {
    ...mapState("Shift", ["shiftFilters"])
  }
})
export default class ShiftMixin extends Mixins(AuthenticateMixin) {
  timerRef?: ReturnType<typeof setInterval>;
  shiftFilters!: ShiftFilterDto;

  getInitials (name: string): string {
    const names = name.split(" ")
    return `${names[0].charAt(0)}${names[1] ? names[1].charAt(0) : ""}`
  }

  getTimes(time: string, field: number, char: string): string {
    const times = time.split(char);
    if (times.length < field) {
      return "";
    }
    return times[field];
  }

  async getShifts(isKanban: boolean, officeId?: number): Promise<void> {
    this.shiftFilters.officeId = officeId ?? null;
    this.$store.dispatch("Shift/resetJobPosts");

    if (isKanban) {
      this.shiftFilters.startDate = getCurrentIsoDate();
      await this.$store.dispatch("Shift/getShifts", this.shiftFilters);
    }
    else {
      await this.$store.dispatch("Shift/getShifts", this.shiftFilters);
    }

    if (officeId) {
      await this.$store.dispatch("Shift/getOfficeRatings", officeId);
    }
  }

  setLoading(value: boolean): void {
    this.$store.commit("Shift/updateField", {
      path: "loading",
      value: value
    });
  }
}